<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="16rem"
      style="width: 80%"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">灌溉设备详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="设备名称"
            prop="equipmentName"
          >
            <el-input
              v-model="form.equipmentName"
              :disabled="!IsEdit"
              placeholder="请输入名称，限10个字"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="设备编号"
            prop="equipmentNo"
          >
            <el-input
              v-model="form.equipmentNo"
              v-bind:disabled="!IsEdit"
              placeholder="请输入设备编号"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="IP地址" prop="equipmentIp">
            <el-input
              v-model="form.equipmentIp"
              v-bind:disabled="!IsEdit"
              placeholder="请输入IP地址"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="端口" prop="equipmentPort">
            <el-input
              type="number"
              v-model="form.equipmentPort"
              v-bind:disabled="!IsEdit"
              placeholder="请输入端口"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="设备分类" prop="categoryCode">
            <treeselect
              v-model="form.categoryCode"
              :options="categoryList"
              :disabled="!IsEdit"
              noResultsText="暂无选择项"
              placeholder="请选择区域"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="区域" prop="areaCode">
            <treeselect
              v-model="form.areaCode"
              :options="regionData"
              :disabled="!IsEdit"
              noResultsText="暂无选择项"
              placeholder="请选择区域"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="安装位置" prop="equipmentLocation">
            <el-input
              v-model="form.equipmentLocation"
              v-bind:disabled="!IsEdit"
              placeholder="请输入安装位置"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="11">
          <el-form-item label="经纬度" prop="jwD">
            <el-input
              v-model="form.jwD"
              v-bind:disabled="!IsEdit"
              placeholder="请选择经纬度"
            ></el-input>
          </el-form-item>
        </el-col>
        <ZjLngLatSelect
            :point_lng="form.longitude"
            :point_lat="form.latitude"
            style="margin-left: 0.5rem"
            @onGotLngLat="onGotLngLat"
          ></ZjLngLatSelect>
      </el-row>
      
      <el-row>
        <el-col :span="24">
          <el-form-item label="描述" prop="equipmentDesc">
            <el-input
              v-model="form.equipmentDesc"
              v-bind:disabled="!IsEdit"
              type="textarea"
              rows="5"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-form-item class="left">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { addEquipment, getEquipmentById, updateEquipment, listEquipmentCategory } from "@/api/src/equipment";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "WaterEquipmentInfo",
  controller: "UI",
  action: "WaterEquipmentInfo",
  components: {
    Treeselect
  },
  data() {
    return {
      form: {
        equipmentName: '',
        equipmentNo: '',
        equipmentIp: '',
        equipmentPort: null,
        categoryCode: null,
        areaCode: null,
        equipmentLocation: '',
        longitude: '',
        latitude: '',
        jwD: null,
        equipmentDesc: ''
      },
      rules: {
        equipmentName: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
        ],
        categoryCode: [
          { required: true, message: "请选择设备分类", trigger: "blur" },
        ],
        areaCode: [
          { required: true, message: "请选择设备区域", trigger: "change" },
        ],
        jwD: [
          { required: true, message: "请选择经纬度", trigger: "change" },
        ],
      },
      // 是否可编辑
      IsEdit: false,
      // 区域数据
      regionData: [],
      // 设备分类数据
      categoryList: []
    };
  },
  created: function() {
    if(this.$route.query.areaTree){
      this.regionData = this.$route.query.areaTree
    }
    if (this.$route.query.id) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
    if(this.$route.query.categoryCode){
      this.getEquipmentCategory();
    }
  },
  methods: {
    // 查询设备分类
    getEquipmentCategory(){
      listEquipmentCategory({parentCode: this.$route.query.categoryCode}).then(response =>{
        this.categoryList = this.handleTree(response.rows, "id", "pid");
        // 修改tree字段
        const mapTree = obj => {
          const haveChildren = Array.isArray(obj.children) && obj.children.length > 0;
          return{
            id: obj.categoryCode,
            label: obj.categoryName,
            children: haveChildren ? obj.children.map(i => mapTree(i)) : undefined
          }
        }
        this.categoryList = this.categoryList.map(obj => mapTree(obj));
      });
    },
    // 选择经纬度
    onGotLngLat(obj) {
      this.form.longitude = obj.lng || 0;
      this.form.latitude = obj.lat || 0;
      this.form.jwD = obj.lng + ',' + obj.lat;
    },
    // 查询数据
    search() {
      getEquipmentById(this.$route.query.id).then(response => {
        const data = response.data;
        if(data.longitude != null && data.latitude != null){
          data.jwD = data.longitude + ',' + data.latitude;
        }
        this.form = Object.assign({},this.form,data);
      });
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存按钮
    saveForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.$route.query.id) {
            updateEquipment(this.form).then(response => {
              this.$message({type: "success", message: "修改成功"});
              this.$router.go(-1);
            });
          } else {
            this.form.onlineStatus = '2';
            addEquipment(this.form).then(response => {
              this.$message({type: "success", message: "新增成功"});
              this.$router.go(-1);
            });
          }
        }
      });
    },
  },
};
</script>
<style scoped>
::v-deep .vue-treeselect__control{
  height: 4rem;
}
::v-deep .vue-treeselect__placeholder, 
::v-deep .vue-treeselect__single-value{
  line-height: unset;
}
::v-deep .vue-treeselect__control,
::v-deep .vue-treeselect--open-below,
::v-deep .vue-treeselect__menu{
  border-radius: 0;
}
</style>